import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const formTemplate = htmlE`
<div
  class="sharing-modal"
>
      <form>
        <table class="sharing-modal-card-container">
          <tr>
            <td>
              <label for="filesToShare" class="text-sm has-text-weight-semibold" data-i18n-key="sharing">
                Sharing
              </label>
            </td>
            <td>
              <div>
                <textarea class="files-to-share" rows="3" id="filesToShare" name="filesToShare" readonly>${({
                  files,
                }) => utils.textEncode(files || "")}</textarea>
              </div>
            </td>
          </tr>
          ${({
            filesLength,
            hasFolder,
            shareWindowFlagDirectLinkForFile,
            shareWindowDisableDirectLinkForFile,
          }) => {
            if (
              filesLength === 1 &&
              !hasFolder &&
              !shareWindowDisableDirectLinkForFile
            ) {
              return `<tr class="external is-hidden" config="directLink">
              <td></td>
              <td>
                <div>
                  <input
                    ${shareWindowFlagDirectLinkForFile ? "checked" : ""}
                    type="checkbox"
                    id="direct_link"
                    name="direct_link"
                  />
                  <label for="direct_link" data-i18n-key="directLink">
                    Direct link to file?
                  </label>
                </div>
              </td>
                </tr>`;
            }
            return "";
          }}
          ${({
            hideShareMethod,
            hideInternalShareMethod,
            hideExternalShareMethod,
            shareMethod,
          }) => {
            if (!hideShareMethod) {
              if (hideInternalShareMethod && hideExternalShareMethod) {
                return "";
              }
              return `<tr config="shareMethod">
              <td>
                <label class="text-sm has-text-weight-semibold" data-i18n-key="shareMethod">
                  Share Method
                </label>
              </td>

              <td>
              <div class="is-flex is-flex-wrap-wrap">
              ${
                !hideInternalShareMethod
                  ? `<div
              class="is-flex is-align-items-center mr-2"
              config="shareMethodInternal"
            >
              <input
                ${shareMethod?.toLowerCase() === "internal" ? "checked" : ""}
                type="radio"
                id="internalShare"
                value="internal"
                name="shareType"
              />
              <label
                class="text-sm ml-2"
                for="internalShare"
                data-i18n-key="internalShare"
              >
                Internal Share
              </label>
            </div>`
                  : ``
              }
              ${
                !hideExternalShareMethod
                  ? `<div
                class="is-flex is-align-items-center mr-2"
                config="shareMethodExternal"
              >
                <input
                  ${shareMethod?.toLowerCase() === "internal" ? "" : "checked"}
                  type="radio"
                  id="externalShare"
                  value="external"
                  name="shareType"
                />
                  <label
                  class="text-sm ml-2"
                  for="externalShare"
                  data-i18n-key="externalShare"
                >
                  External Share
                </label>
              </div>`
                  : ``
              }
                </div>
              </td>
            </tr>`;
            }
            return "";
          }}

          <tr class="internal" config="userNames">
            <td>
              <label
                for="shareUsernames"
                class="text-sm has-text-weight-semibold"
                data-i18n-key="userNames"
              >
                Usernames
              </label>
            </td>
            <td>
              <input
                data-validate="required"
                data-mark-error="true"
                data-inline-error="true"
                name="shareUsernames"
                class="input modal-input"
                id="shareUsernames"
              />
              ${({
                shareWindowEnableMultipleUsernameSelection,
                shareWindowEnableUsernameLookup,
              }) => {
                if (
                  shareWindowEnableMultipleUsernameSelection &&
                  shareWindowEnableUsernameLookup
                ) {
                  return `
                <input
                  data-validate="required"
                  data-mark-error="true"
                  data-inline-error="true"
                  name="shareUsernames_multiselect"
                  class="input modal-input is-hidden"
                  id="shareUsernames-multiselect"
                 />`;
                }
              }}
              <div>
                <label
                  id="ShareWindowUsernamesLabelHelpText"
                  class="autocomplete-wrapper"
                  for="shareUsernames"
                  data-i18n-key="separateMultipleUsernamesWithCommas"
                  >(Separate multiple usernames with commas.)</label
                >

                ${({
                  shareWindowEnableMultipleUsernameSelection,
                  shareWindowEnableUsernameLookup,
                  hideShareMultipleSelectionQuick,
                }) => {
                  if (
                    shareWindowEnableMultipleUsernameSelection &&
                    shareWindowEnableUsernameLookup &&
                    !hideShareMultipleSelectionQuick
                  ) {
                    return `
                    <div class="is-flex is-align-items-center mt-2">
                    <input
                      id="shareUsernameInput"
                      type="checkbox"
                      is_key="true"
                      value="multiselect"
                      checked
                      name="shareUsernameInput"
                    />
                    <label
                      class="ml-2"
                      for="shareUsernameInput"
                      data-i18n-key="selectMultipleUserQuickly"
                    >
                    Select multiple users quickly
                    </label>
                  </div>
                    `;
                  }
                }}
              </div>
            </td>
          </tr>

          ${({
            shareWindowHidePermissions,
            shareWindowDefaultPermissions = "",
            shareAllowPrivsModification,
          }) => {
            if (!shareWindowHidePermissions && !shareAllowPrivsModification) {
              return `<tr class="internal" config="Permissions">
              <td>
                <label
                  for="shareUsernamePermissions"
                  class="text-sm has-text-weight-semibold"
                  data-i18n-key="permissions"
                >
                  Permissions
                </label>
              </td>
              <td>
                <div class="is-flex">
                  <div class="is-flex is-align-items-center mr-2">
                    <input
                      type="checkbox"
                      id="shareUsernamePermissionsDownload"
                      is_key="true"
                      value="priv_read"
                      name="shareUsernamePermissions"
                      ${
                        shareWindowDefaultPermissions &&
                        shareWindowDefaultPermissions.indexOf("download") >=
                          0 &&
                        "checked"
                      }
                    />
                    <label
                      class="text-sm ml-2"
                      for="shareUsernamePermissionsDownload"
                      id="ShareWindowDownloadLabelText"
                      data-i18n-key="Download"
                    >
                      Download
                    </label>
                  </div>
                  <div class="is-flex is-align-items-center mr-2">
                    <input
                      type="checkbox"
                      id="shareUsernamePermissionsUpload"
                      is_key="true"
                      value="priv_write"
                      name="shareUsernamePermissions"
                      ${
                        shareWindowDefaultPermissions &&
                        shareWindowDefaultPermissions.indexOf("upload") >= 0 &&
                        "checked"
                      }
                    />
                    <label
                      class="text-sm ml-2"
                      for="shareUsernamePermissionsUpload"
                      id="ShareWindowUploadLabelText"
                      data-i18n-key="Upload"
                    >
                      Upload
                    </label>
                  </div>
                  <div class="is-flex is-align-items-center mr-2">
                    <input
                      type="checkbox"
                      id="shareUsernamePermissionsDelete"
                      is_key="true"
                      value="priv_delete"
                      name="shareUsernamePermissions"
                      ${
                        shareWindowDefaultPermissions &&
                        shareWindowDefaultPermissions.indexOf("delete") >= 0 &&
                        "checked"
                      }
                    />
                    <label
                      class="text-sm ml-2"
                      for="shareUsernamePermissionsDelete"
                      id="ShareWindowDeleteLabelText"
                      data-i18n-key="Delete"
                    >
                      Delete
                    </label>
                  </div>
                </div>
              </td>
            </tr>`;
            }

            return "";
          }}

          ${({ hideShareType, defaultShareMethod }) => {
            if (!hideShareType) {
              return `
              <tr class="external" config="shareType">
              <td>
                <label
                  id="ShareWindowShareTypeLabelText"
                  class="text-sm has-text-weight-semibold"
                  data-i18n-key="shareType"
                >
                  Share Type
                </label>
              </td>
              <td>
                <div class="col-span-2">
                  <div class="is-flex">
                    <div class="is-flex is-align-items-center mr-2">
                      <input
                        type="radio"
                        value="copy"
                        name="publishType"
                        id="chkCopy"
                        ${defaultShareMethod === "copy" && "checked"}
                      />
                      <label
                        class="text-sm ml-2"
                        for="chkCopy"
                        data-i18n-key="Copy"
                      >
                        Copy
                      </label>
                    </div>
                    <div class="is-flex is-align-items-center mr-2">
                      <input
                        type="radio"
                        value="reference"
                        name="publishType"
                        id="chkReference"
                        ${
                          defaultShareMethod !== "copy" &&
                          defaultShareMethod !== "move" &&
                          "checked"
                        }
                      />
                      <label
                        class="text-sm ml-2"
                        for="chkReference"
                        data-i18n-key="reference"
                      >
                        Reference
                      </label>
                    </div>
                    <div class="is-flex is-align-items-center mr-2 form-move advanced">
                      <input
                        type="radio"
                        value="move"
                        name="publishType"
                        id="chkMove"
                        ${defaultShareMethod === "move" && "checked"}
                      />
                    <label data-i18n-key="move" class="text-sm ml-2" for="chkMove">Move</label>
                  </div>
                </div>
              </div>
            </td>
            </tr>`;
            }
            return "";
          }}

          ${({ hideShareSendEmail, sendEmail }) => {
            if (!hideShareSendEmail) {
              return `
              <tr>
                <td>
                  <label class="text-sm has-text-weight-semibold" data-i18n-key="sendEmail"> Send Email </label>
                </td>
                <td>
                  <input id="sendEmail" name="sendEmail"
                      ${sendEmail === true ? "checked" : ""}
                      type="checkbox" />
                </td>
            </tr>`;
            }

            return "";
          }}

          ${({ hideShareExpiresRow, EXPIREDAYS }) => {
            if (!hideShareExpiresRow) {
              return `<tr class="expiresIn" config="expiresIn">
              <td>
                <label for="txtdays" class="text-sm has-text-weight-semibold" data-i18n-key="expires">
                  Expires
                </label>
              </td>
              <td class="col-span-2 is-flex">
                <div>
                  <input
                    id="txtdays"
                    value= ${EXPIREDAYS ? EXPIREDAYS : "29"}
                    name="txtdays"
                    class="input modal-input"
                    type="number"
                    class="w-70px"
                    min="0"
                  />
                </div>
                <label for="txtdays" class="text-sm mx-1" data-i18n-key="days">
                  Days
                </label>
                <div id="date-picker-parent">
                  <input
                    class="input modal-input"
                    name="txtDate"
                    type="date"
                    id="date-picker"
                  />
                </div>
                <div id="time-picker-parent" class="sharing-form-time mx-2">
                  <input
                    class="input modal-input"
                    name="txtTime"
                    type="time"
                    id="time-picker"
                  />
                </div>
              </td>
            </tr>`;
            }
            return "";
          }}

          ${({ hideShareLoginsRow }) => {
            if (!hideShareLoginsRow) {
              return `<tr class="external maxUses" config="maxUses">
              <td>
                <label
                  for="logins"
                  class="text-sm has-text-weight-semibold"
                  data-i18n-key="maximumNumberOfUses"
                >
                  Maximum Number of uses
                </label>
              </td>
              <td class="col-span-2">
                <div class="select modal-input text-sm">
                  <select
                    id="logins"
                    name="logins"
                    class="primary-select modal-input py-0"
                  >
                    <option value="-1" data-i18n-key="unlimited">
                      Unlimited
                    </option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                  </select>
                </div>
              </td>
            </tr>`;
            }
            return "";
          }}

          ${({ hideShareFromRow }) => {
            if (!hideShareFromRow) {
              return `
              <tr class="external shareFrom" config="shareFrom">
            <td>
              <label for="emailFrom" class="text-sm has-text-weight-semibold" data-i18n-key="from">
                From
              </label>
            </td>
            <td class="col-span-2">
              <input
                data-validate="required,email"
                data-mark-error="true"
                data-inline-error="true"
                id="emailFrom"
                name="emailFrom"
                class="input modal-input"
              />
            </td>
          </tr>
              `;
            }
            return "";
          }}

          ${({ hideShareToRow }) => {
            if (!hideShareToRow) {
              return `
              <tr class="external shareTo" config="shareTo">
            <td>
              <label for="emailTo" class="text-sm has-text-weight-semibold" data-i18n-key="to">
                To
              </label>
            </td>
            <td class="col-span-2">
              <input
                data-validate="required,multiple-emails"
                data-mark-error="true"
                data-inline-error="true"
                id="emailTo"
                name="emailTo"
                class="input modal-input"
              />
            </td>
          </tr>
              `;
            }
            return "";
          }}

          ${({ hideShareCCRow }) => {
            if (!hideShareCCRow) {
              return `
              <tr class="external shareCC" config="shareCC">
              <td>
                <label for="emailCc" class="text-sm has-text-weight-semibold" data-i18n-key="cc">
                  CC
                </label>
              </td>
              <td class="col-span-2">
                <input
                  data-validate="multiple-emails"
                  data-mark-error="true"
                  data-inline-error="true"
                  id="emailCc"
                  name="emailCc"
                  class="input modal-input"
                />
              </td>
            </tr>
              `;
            }
            return "";
          }}

          ${({ hideShareBCCRow }) => {
            if (!hideShareBCCRow) {
              return `
              <tr class="external shareBCC" config="shareBCC">
            <td>
              <label for="emailBcc" class="text-sm has-text-weight-semibold" data-i18n-key="bcc">
                BCC
              </label>
            </td>
            <td class="col-span-2">
              <input
                data-validate="multiple-emails"
                data-mark-error="true"
                data-inline-error="true"
                id="emailBcc"
                name="emailBcc"
                class="input modal-input"
              />
            </td>
          </tr>
              `;
            }
            return "";
          }}

          ${({ hideShareReplyToRow }) => {
            if (!hideShareReplyToRow) {
              return `
              <tr class="external shareReplyTo" config="shareReplyTo">
            <td>
              <label for="emailReplyTo" class="text-sm has-text-weight-semibold" data-i18n-key="replyTo">
                Reply to
              </label>
            </td>
            <td class="col-span-2">
              <input
                data-validate="multiple-emails"
                data-mark-error="true"
                data-inline-error="true"
                id="emailReplyTo"
                name="emailReplyTo"
                class="input modal-input"
              />
            </td>
          </tr>
              `;
            }
            return "";
          }}

          ${({ hideShareSubjectRow, readonlyShareSubject }) => {
            if (!hideShareSubjectRow) {
              return `
              <tr class="shareSubject" config="shareSubject">
            <td>
              <label for="emailSubject" class="text-sm has-text-weight-semibold" data-i18n-key="subject">
                Subject
              </label>
            </td>
            <td class="col-span-2">
              <input
                id="emailSubject"
                name="emailSubject"
                class="input modal-input"
                value="Sharing: A new file is being shared with you."
                ${readonlyShareSubject ? "readonly" : ""}
              />
            </td>
          </tr>
              `;
            }
            return "";
          }}

          ${({
            hideShareBodyRow,
            paths,
            defaultEmailBody,
            shareEmailBodyNoHTMLArea,
          }) => {
            if (!hideShareBodyRow) {
              let formattedFiles = paths ? utils.textEncode(paths) : "";
              if (!shareEmailBodyNoHTMLArea && paths) {
                formattedFiles = paths
                  .split("\r\n")
                  .map((path) => `<p>${utils.doubleEncodeHtml(path)}</p>`)
                  .join("");
              }
              return `
              <tr class="shareBody" config="shareBody">
            <td>
              <label for="emailBody" class="text-sm has-text-weight-semibold" data-i18n-key="body">
                Body
              </label>
            </td>
            <td>
              <div
                id="emailBodyTemplatePanel"
                class="select is-hidden modal-input text-sm mb-2"
              >
                <select
                  class="primary-select modal-input py-0"
                  name="emailBodyTemplate"
                  id="emailBodyTemplate"
                ></select>
              </div>
              <textarea
                id="emailBody"
                name="emailBody"
                rows="10"
                class="textarea w-full"
              >${
                defaultEmailBody
                  ? utils.textEncode(defaultEmailBody)
                  : `A user would like to share a file with you. This link will expire on {date} at {time}.\n\n{web_link} \r\n\r\n ${formattedFiles}`
              } </textarea>
            </td>
          </tr>
              `;
            }
            return "";
          }}

          ${({ hideShareComments }) => {
            if (!hideShareComments) {
              return `<tr class="shareComments" config="shareComments">
              <td>
                <label
                  for="share_comments"
                  class="text-sm has-text-weight-semibold"
                  data-i18n-key="comments"
                >
                  Comments
                </label>
              </td>
              <td class="col-span-2">
                <textarea
                  id="share_comments"
                  name="share_comments"
                  rows="3"
                  class="textarea w-full"
                ></textarea>
              </td>
            </tr>`;
            }
            return "";
          }}

        <tr class="external">
          <td>
          </td>
          <td>
            <div class="sharing-options is-flex is-flex-wrap-wrap">
              ${({
                hideAdvancedOption,
                shareAdvanced,
                shareAllowUploads,
                defaultShareMethod,
              }) => {
                if (!hideAdvancedOption) {
                  return `
                  <span
                class="is-flex is-align-items-center mr-2 shareAdvanced"
                config="shareAdvanced"
              >
                <input
                  ${
                    shareAdvanced ||
                    shareAllowUploads ||
                    defaultShareMethod === "move"
                      ? "checked"
                      : ""
                  }
                  type="checkbox"
                  id="advanced"
                  value="advanced"
                  name="advanced"
                />
                <label
                  class="text-sm ml-2"
                  for="advanced"
                  data-i18n-key="advanced"
                >
                  Advanced
                </label>
              </span>`;
                }
                return "";
              }}

              ${({ hideAttachThumbnailOption, shareThumbnail }) => {
                if (!hideAttachThumbnailOption) {
                  return `
                  <span
                  class="is-flex is-align-items-center mr-2 shareAttachThumbnail"
                  config="shareAttachThumbnail"
                >
                  <input
                    ${!shareThumbnail ? "" : "checked"}
                    type="checkbox"
                    id="attach"
                    value="attach"
                    name="attach"
                  />
                  <label
                    class="text-sm ml-2"
                    for="attach"
                    data-i18n-key="attachThumbnail"
                  >
                    Attach Thumbnail
                  </label>
                </span>`;
                }
                return "";
              }}

              ${({ hideAttachFilesOption, shareFiles }) => {
                if (!hideAttachFilesOption) {
                  return `
                  <span
                class="is-flex is-align-items-center mr-2 shareAttachFiles"
                config="shareAttachFiles"
              >
                <input
                  ${!shareFiles ? "" : "checked"}
                  type="checkbox"
                  id="attach_real"
                  value="attach_real"
                  name="attach_real"
                />
                <label
                  class="text-sm ml-2"
                  for="attach_real"
                  data-i18n-key="attachFiles"
                >
                  Attach Files
                </label>
              </span>`;
                }
                return "";
              }}

              ${({
                hideFullAccessOption,
                shareAllowUploads,
                shareAllowUploadsPrivs,
                shareAllowPrivsModification,
              }) => {
                if (!hideFullAccessOption) {
                  return `
                <div class="advanced is-flex">
                  <span
                  class="is-flex is-align-items-center mr-2 shareFullAccess"
                  config="shareFullAccess"
                >
                  <input
                    type="checkbox"
                    id="fullaccess"
                    value="full"
                    name="fullaccess"
                    ${shareAllowUploads ? "checked" : ""}
                  />
                  <label
                    class="text-sm ml-2"
                    for="fullaccess"
                    data-i18n-key="fullAccess"
                  >
                    Full Access
                  </label>
                </span>
                ${
                  !shareAllowPrivsModification && shareAllowUploadsPrivs
                    ? `<p class="text-sm is-inline">${shareAllowUploadsPrivs}</p>`
                    : ""
                }
                </div>
                `;
                }
                return "";
              }}

              ${({ shareWindowHideDownloadButtonVisible }) => {
                if (shareWindowHideDownloadButtonVisible) {
                  return `<span
                  class="is-flex is-align-items-center mr-2 shareHideDownloadButton"
                  config="shareHideDownloadButton"
                >
                  <input
                    type="checkbox"
                    id="hide_download"
                    value="hide_download"
                    name="hide_download"
                  />
                  <label
                    class="text-sm ml-2"
                    for="hide_download"
                    data-i18n-key="hideDownloadButton"
                  >
                    Hide download button
                  </label>
                </span>`;
                }
                return "";
              }}
            </div>
          </td>
        </tr>

        ${({ shareAllowPrivsModification }) => {
          if (shareAllowPrivsModification) {
            return `
        <tr
            class="sharePermissions fullaccess customPermissions"
            config="sharePermissions"
          >
            <td>
              <label class="text-sm has-text-weight-semibold" data-i18n-key="permissions">
                Permissions
              </label>
            </td>
            <td>
              <div
                  class="sharing-permissions is-flex is-flex-wrap-wrap"
                >
                  <span
                    class="is-flex is-align-items-center mr-2 sharePermissionDownload"
                    config="sharePermissionDownload"
                  >
                    <input
                      type="checkbox"
                      class="custom_priv_option"
                      id="priv_read"
                    />
                    <label
                      class="text-sm ml-2"
                      for="priv_read"
                      data-i18n-key="Download"
                    >
                      Download
                    </label>
                  </span>
                  <span
                    class="is-flex is-align-items-center mr-2 sharePermissionUpload"
                    config="sharePermissionUpload"
                  >
                    <input
                      type="checkbox"
                      class="custom_priv_option"
                      id="priv_write"
                    />
                    <label
                      class="text-sm ml-2"
                      data-i18n-key="Upload"
                      for="priv_write"
                      >Upload</label
                    >
                  </span>
                  <span
                    class="is-flex is-align-items-center mr-2 sharePermissionView"
                    config="sharePermissionView"
                  >
                    <input
                      type="checkbox"
                      class="custom_priv_option"
                      id="priv_view"
                    />
                    <label
                      class="text-sm ml-2"
                      data-i18n-key="view"
                      for="priv_view"
                      >View</label
                    >
                  </span>
                  <span
                    class="is-flex is-align-items-center mr-2 sharePermissionSlideshow"
                    config="sharePermissionSlideshow"
                  >
                    <input
                      type="checkbox"
                      class="custom_priv_option"
                      id="priv_slideshow"
                    />
                    <label
                      class="text-sm ml-2"
                      data-i18n-key="Slideshow"
                      for="priv_slideshow"
                    >
                      Slideshow
                    </label>
                  </span>
                  <span
                    class="is-flex is-align-items-center mr-2 sharePermissionDelete"
                    config="sharePermissionDelete"
                  >
                    <input
                      type="checkbox"
                      class="custom_priv_option"
                      id="priv_delete"
                    />
                    <label
                      class="text-sm ml-2"
                      data-i18n-key="Delete"
                      for="priv_delete"
                    >
                      Delete
                    </label>
                  </span>
                  <span
                    class="is-flex is-align-items-center mr-2 sharePermissionDeleteFolder"
                    config="sharePermissionDeleteFolder"
                  >
                    <input
                      type="checkbox"
                      class="custom_priv_option"
                      id="priv_deletedir"
                    />
                    <label
                      class="text-sm ml-2"
                      data-i18n-key="deleteFolder"
                      for="priv_deletedir"
                    >
                      Delete Folder
                    </label>
                  </span>
                  <span
                    class="is-flex is-align-items-center mr-2 sharePermissionCreateFolder"
                    config="sharePermissionCreateFolder"
                  >
                    <input
                      type="checkbox"
                      class="custom_priv_option"
                      id="priv_makedir"
                    />
                    <label
                      class="text-sm ml-2"
                      data-i18n-key="Create Folder"
                      for="priv_makedir"
                    >
                      Create Folder
                    </label>
                  </span>
                  <span
                    class="is-flex is-align-items-center mr-2 sharePermissionRename"
                    config="sharePermissionRename"
                  >
                    <input
                      type="checkbox"
                      class="custom_priv_option"
                      id="priv_rename"
                    />
                    <label
                      class="text-sm ml-2"
                      data-i18n-key="Rename"
                      for="priv_rename"
                    >
                      Rename
                    </label>
                  </span>
                  <span
                    class="is-flex is-align-items-center mr-2 sharePermissionResumeTransfers"
                    config="sharePermissionResumeTransfers"
                  >
                    <input
                      type="checkbox"
                      class="custom_priv_option"
                      id="priv_resume"
                    />
                    <label
                      class="text-sm ml-2"
                      data-i18n-key="resume"
                      for="priv_resume"
                    >
                      Resume Transfers
                    </label>
                  </span>
                </div>
            </td>
          </tr>`;
          }
          return "";
        }}

          ${({ showShareKeywords }) => {
            if (showShareKeywords) {
              return `<tr class="shareKeywords" config="shareKeywords">
              <td>
                <label
                  for="share_keywords"
                  class="text-sm has-text-weight-semibold"
                  data-i18n-key="keywords"
                >
                  Keywords
                </label>
              </td>
              <td class="col-span-2">
                <textarea
                  id="share_keywords"
                  name="share_keywords"
                  rows="3"
                  class="textarea w-full"
                ></textarea>
              </td>
            </tr>`;
            }

            return "";
          }}

          ${({ altTempAccount }) => {
            if (altTempAccount) {
              return `<tr
              class="shareAlternateTempAccount"
              config="shareAlternateTempAccount"
            >
              <td>
                <label
                  for="share_alt_tempaccount"
                  class="text-sm has-text-weight-semibold"
                  data-i18n-key="alternateTempAccount"
                >
                  Alternate Temp Account
                </label>
              </td>
              <td>
                <input class="input modal-input id="share_alt_tempaccount"
                name="share_alt_tempaccount" type="text" />
                <div class="warning text-sm text-secondaryMain is-flex mt-1">
                    <i class="icon-exclamation-sign"></i>
                    <span data-i18n-key="alternateTempaccountInfo">
                      Use this field to set alternate TempAccount while sharing,
                      'TempAccount_' will be added as a prefix to the name used here.
                    </span>
                  </div>
              </td>
            </tr>`;
            }

            return "";
          }}

          ${({
            hideUserPassGenerationOption,
            forceGeneratePasswordShare,
            hideUserGenerationOption,
            hidePassGenerationOption,
          }) => {
            if (!hideUserPassGenerationOption || forceGeneratePasswordShare) {
              return `
              <tr
            class="external ${
              forceGeneratePasswordShare ? "" : "advanced is-hidden"
            } shareUserPassConfig"
            config="shareUserPassConfig"
          >
            <td>
              <label class="text-sm has-text-weight-semibold" data-i18n-key="userPassword">
                Username/Password
              </label>
            </td>
            <td class="shareUserGenerationPanel">
              <div class="shareUserPassGeneration">
                <div class="is-flex">
                ${
                  !forceGeneratePasswordShare
                    ? `<label class="is-flex is-align-items-center mr-2">
                <input
                  checked
                  name="generateUserPass"
                  type="radio"
                  id="ShareGeneratePassAuto"
                  value="auto"
                />
                <span class="text-sm ml-2" data-i18n-key="auto">Auto</span>
              </label>`
                    : ``
                }
                ${
                  hideUserGenerationOption && hidePassGenerationOption
                    ? ""
                    : `<label class="is-flex is-align-items-center mr-2">
                    <input
                      ${forceGeneratePasswordShare && "checked"}
                      name="generateUserPass"
                      type="radio"
                      id="ShareGeneratePass"
                      value="generate"
                    />
                    <span class="text-sm ml-2" data-i18n-key="generate"
                      >Generate</span
                    >
                  </label>`
                }
                </div>
                <div class="generate is-flex is-flex-wrap-wrap is-align-items-end mt-2 mb-2">
                  ${
                    hideUserGenerationOption
                      ? ""
                      : `<div class="is-flex is-flex-direction-column mr-2">
                      <label data-i18n-key="username" class="text-sm">Username</label>
                    <input
                      class="input modal-input"
                      type="text"
                      id="share_generate_user"
                      placeholder="Username"
                      data-i18n-key="username"
                      data-i18n-attr-to-update="placeholder"
                      name="temp_username"
                    />
                  </div>`
                  }
                  ${
                    hidePassGenerationOption
                      ? ""
                      : `<div class="is-flex is-flex-direction-column mr-2">
                      <label data-i18n-key="password" class="text-sm">Password</label>
                    <input
                      class="input modal-input"
                      type="text"
                      id="share_generate_pass"
                      placeholder="Password"
                      data-i18n-key="password"
                      data-i18n-attr-to-update="placeholder"
                      name="temp_password"
                    />
                  </div>`
                  }
                  <span class="is-flex is-align-items-center mr-2">
                    <button
                      class="primary-button is-bordered p-1 text-xs"
                      type="button"
                      id="shareGenerateUserPass"
                      data-i18n-key="generate"
                      >Generate
                    </button>
                  </span>
                </div>
              </div>
            </td>
          </tr>
              `;
            }

            return "";
          }}
        </table>
      </form>

</div>`;

const resultTemplate = htmlE`
<div class="sharing-modal is-flex is-flex-direction-column gap-3">

<div class="is-flex">
<label for="filesToShare" class="text-sm has-text-weight-semibold" data-i18n-key="sharing">
Sharing
</label>
      <span class="ml-1 mr-1"> : </span>
     <textarea class="files-to-share" rows="3" id="filesToShare" name="filesToShare" readonly>${({
       files,
     }) => utils.textEncode(files || "")}</textarea>
    </div>

${({ hasEmailFailed }) => {
  if (hasEmailFailed) {
    return `<p data-i18n-key="smtpFailedToSendTheEmail" class="text-error text-sm">SMTP failed to send the email. Check server logs</p>`;
  }
}}

${({ shareWindowNoUserInfoAfterShare, shareUsernames, username, password }) => {
  if (!shareWindowNoUserInfoAfterShare && !shareUsernames) {
    return `
    <div>
      <label class="text-sm has-text-weight-semibold" data-i18n-key="username">username</label>
      <span> : </span>
      <span>${utils.textEncode(username || "")}</span>
    </div>

    <div>
        <label class="text-sm has-text-weight-semibold" data-i18n-key="password">password</label>
        <span> : </span>
        <span id="shareResultPassword">${utils.textEncode(
          password || ""
        )}</span>
    </div>
`;
  }
  return "";
}}

${({ hideShareResultLink, url, shareUsernames }) => {
  if (!hideShareResultLink && !shareUsernames) {
    return `
    <div class="word-break-all">
      <label class="text-sm has-text-weight-semibold" data-i18n-key="link">link</label>
      <span> : </span>
      <span id="shareResultURL">${utils.textEncode(url || "")}</span>
    </div>`;
  }
  return "";
}}

${({ shareUsernames }) => {
  if (shareUsernames) {
    return `
  <div>
    <p class="text-primaryMain">The following users have now been granted access to the shared items.</p>
    <p class="text-primaryMain mt-2">${utils.textEncode(shareUsernames)}</p>
  </div>
`;
  }
}}
</div>`;

const errorResponseTemplate = htmlE`
${({ errorMessage }) => {
  return `<p class="text-error text-sm whitespace-preline">${utils.textEncode(
    errorMessage || ""
  )}</p>`;
}}
`;

export { formTemplate, resultTemplate, errorResponseTemplate };
